module.exports = function() { return __webpack_public_path__ + "homeaway_uk.1RQd1R9jWxfAUOtLeeBy.svg";};